import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/shared/api/apiClient'

export type LegislationCorpusItem = {
  documentId: string
  celex: string
  title: string | null
  inForce: boolean
  type: string | null
  eurlexUrl: string | null
  consolidationVersionDate: string | null
  embeddingReleaseStatus: string | null
  scopeReviewStatus: string
  currentTier: 1 | 2 | 3 | null
  tags: string[]
  flipDetectedAt: string | null
  flipLegalEndDate: string | null
}

export type LegislationCorpusQuery = {
  search?: string
  inForceFilter?: 'in_force' | 'not_in_force' | 'all'
  status?: 'pending' | 'approved' | 'flagged' | 'trashed' | 'all'
  types?: string
  tags?: string
  tiers?: string
  embeddingReleaseStatus?: string
  detectedWithinDays?: number
  legalEndWithinDays?: number
  limit?: number
  offset?: number
}

export type LegislationCorpusResponse = {
  total: number
  limit: number
  offset: number
  items: LegislationCorpusItem[]
}

export const LEGISLATION_CORPUS_QUERY_KEY = 'legislation-corpus'

export function useLegislationCorpus(
  query: LegislationCorpusQuery,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: [LEGISLATION_CORPUS_QUERY_KEY, query],
    queryFn: async () => {
      const { search, ...rest } = query
      const { data } = await apiClient.get<LegislationCorpusResponse>(
        '/radar/legislation-corpus',
        {
          params: {
            ...rest,
            q: search,
          },
        }
      )
      return data
    },
    enabled: options?.enabled ?? true,
  })
}
